// One date/time rendering for the whole Activity tab: the fleet table, the device
// spec grid and the alert list all show the same shape, so they share one formatter
// and differ only in the placeholder they fall back to.
const DATE_TIME_OPTIONS = {
  month: "short",
  day: "numeric",
  year: "numeric",
  hour: "numeric",
  minute: "2-digit",
};

const formatDateTime = (value, emptyLabel) =>
  value ? new Date(value).toLocaleString("en-us", DATE_TIME_OPTIONS) : emptyLabel;

// lastCaptureAt arrives as an ISO string; a device that has never captured is
// "Never" rather than a generic blank
export const formatLastCapture = (isoString) =>
  formatDateTime(isoString, "Never");

// message_timestamp, last_alert_timestamp and alert.timestamp arrive as epoch ms
export const formatTimestamp = (epochMs) => formatDateTime(epochMs, "-");
